import { Common } from '~/models/common';
import { Employee } from '~/models/employee';

export const employeesService = {
	fetch: async (limit: number | undefined = undefined): Promise<Employee.Model[]> => {
		const params = {
			limit,
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*', 'photo.*', 'form.*', 'seo.*'],
		};

		try {
			const response = await $fetch<Employee.Model[]>(Employee.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Employees:', error);

			return [];
		}
	},

	getEmployee: async (alias: string): Promise<Employee.Model | null> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
				alias,
			},
			fields: ['*', 'photo.*', 'form.*', 'seo.*'],
		};

		try {
			const [response] = await $fetch<Employee.Model[]>(Employee.api, {
				method: 'POST',
				body: { params },
			});

			return response || null;
		} catch (error) {
			console.error('Failed to fetch Employee:', error);

			return null;
		}
	},
};
